<template>
  <div class="offers">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'offers-view'
}
</script>

<style lang="scss" scoped>

</style>
